<div class="quote-list">
  <div class="tile-content">
    <div class="top-heading">
      <p class="accNo">
        {{ "orderTracking.soldToCstmr" | cxTranslate }}
        <span>
          <strong> {{ tableData?.customerAccountNumber }}</strong>
        </span>
      </p>
      <p>
        {{ "orderTracking.legalEntity" | cxTranslate }}
        <span>
          <strong> {{ tableData?.legalEntity }}</strong>
        </span>
      </p>
    </div>
    <div class="statusTile">
      <vs-status-tiles
        (filteredTile)="onTileClick($event)"
        [tiles]="quoteTiles"
        [currentStatusType]="firstStatusType"
      >
      </vs-status-tiles>
    </div>
  </div>

  <div class="before-table">
    <div class="leftcontent">
      <a
        matTooltipClass="vs-tooltip capitalize"
        matTooltip='{{ "orderTracking.downloadTooltipTxt" | cxTranslate }}'
        (click)="downloadXLS()"
      >
        <em class="icons download icon-size"></em>
        <span class="btn-txt">{{ "orderTracking.downloadXls" | cxTranslate }}</span></a
      >
      <div class="refresh" *ngIf="!noData" (click)="refreshList()">
        <em class="material-icons icon-size">refresh</em> <span  class="btn-txt">{{ "orderTracking.refresh" | cxTranslate }}</span>
      </div>
    </div>

    <div class="rightContent">
      <div class="createdby">
        <label class="pl createdbylabel">{{ "orderTracking.createdByHdr" | cxTranslate }}</label>
      <ng-select
      [items]="createdby?.createdByList"
      bindLabel="name"
       placeholder='{{ "orderTracking.allPlaceholder" | cxTranslate }}'
      [closeOnSelect]="true"
      [(ngModel)]="selectedCreated"
        (change)="getselectedCreatedby(selectedCreated)"
    >
      <ng-template ng-option-tmp let-item="item">
       {{ item }}

      </ng-template>
    </ng-select>
    </div>
      <div class="dateRange">
        <label class="pl">{{ "orderTracking.timePeriod" | cxTranslate }}</label>
        <vs-date-range-picker (selectedDateRange)="getDateRange($event)"
          *ngIf="getMonths$ | async"
          [fromMaxDate]="toMinDate"
          [fromMinDate]="fromMaxDate"
          [toMinDate]="toMinDate"
          [toMaxDate]="toMinDate"
          [changeDate]="changeDate"
          (getClearDate)="getClearDate($event)"
        ></vs-date-range-picker>
      </div>
      <div class="search">
        <input
          type="text"
          class="form-control search-btn"
          placeholder='{{ "orderTracking.searchPlaceholder" | cxTranslate }}'
          #search
          name="search"
          (keydown)="searchTermChanged()"
          [(ngModel)]="searchTerm"
          (keydown.enter)="modelChange()"
        />
        <span
          ><em class="material-icons search-icon" (click)="modelChange()"
            >search</em
          ></span
        >
      </div>
    </div>
  </div>

  <div class="example-contaner mat-elevation-z8 tb-parent">
    <div class="left-content" *ngIf="statusFilterTxt">
      {{ this.statusFilterTxt }}
      <em class="material-icons" (click)="clearStatus()">close</em>
    </div>
    <div class="left-content" *ngIf="dateRange">
      {{ this.fromDate.formattedDate }} - {{ this.toDate.formattedDate }}
      <em class="material-icons" (click)="clearDateRange()">close</em>
    </div>
    <div class="left-content" *ngIf="searchcreatedby">
      {{selectedCreated}}
      <em class="material-icons" (click)="clearcreatedbyFilter()">close</em>
    </div>
    <div class="left-content" *ngIf="searchFieldUpdated">
      {{ "orderTracking.search" | cxTranslate }}{{ searchTerm }}
      <em class="material-icons" (click)="clearSearchTerm()">close</em>
    </div>

    <div
      class="clear-link"
      *ngIf="
        dateRange ||
        (searchFieldUpdated && searchTerm.trim().length > 0) ||
        statusFilter || searchcreatedby
      "
    >
      <span class="clear-all" (click)="clearAll()">
        {{ "orderTracking.clearAllBtn" | cxTranslate }}
      </span>
    </div>
    <app-scroll-container
      *ngIf="!noData && !isLoadMoreInProgress"
      [more]="true"
      [scrollDelay]="2000"
      [scrollOffset]="2000"
      (scrolled)="loadMoreOrders()"
      [class.full]="full"
      [class.part]="!full"
    >
      <mat-table
        class="clearfix"
        #table
        [dataSource]="dataSource"
        [ngClass]="{ mt: !dateRange }"
      >
        <!-- Position Column -->
        <ng-container matColumnDef="Order">
          <mat-header-cell *matHeaderCellDef class="tb-heading">
            {{ "orderTracking.orderHeader" | cxTranslate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="tb-content"
          >
            <span (click)="selectedOrder(element.code)"> {{ element.code }} </span>
          </mat-cell>

        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Order Status">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ "orderTracking.orderStatusHeader" | cxTranslate }}
            <em class="material-icons" (click)="increasing('StatusAsc')"
              >keyboard_arrow_up</em
            >
            <em class="material-icons" (click)="decreasing('StatusDsc')"
              >keyboard_arrow_down</em
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ displayStatus(element.orderStatus) }}
          </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="PO Number">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            "orderTracking.poNumberHeader" | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.purchaseOrderNumber }}
          </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="Created By">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ "orderTracking.createdby" | cxTranslate }}
            <em class="material-icons" (click)="increase()"
              >keyboard_arrow_up</em
            >
            <em class="material-icons" (click)="decrease()"
              >keyboard_arrow_down</em
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.createdBy  }}
          </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="PO Date">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ "orderTracking.poDateHeader" | cxTranslate }}
            <em class="material-icons" (click)="increasing('PODateAsc')"
              >keyboard_arrow_up</em
            >
            <em class="material-icons" (click)="decreasing('PODateDsc')"
              >keyboard_arrow_down</em
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.purchaseOrderDate | date: "d MMM, yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Net Price">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            "orderTracking.netPriceHeader" | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.currency }} {{ getNetPrice(element?.totalNetPrice, element?.currency )}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Order Created">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ "orderTracking.orderCreatedHeader" | cxTranslate }}
            <em class="material-icons" (click)="increasing('OrderAsc')"
              >keyboard_arrow_up</em
            >
            <em class="material-icons" (click)="decreasing('OrderDsc')"
              >keyboard_arrow_down</em
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.placed | date: "d MMM, yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Last Updated">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ "orderTracking.lastUpdateHeader" | cxTranslate }}
            <em class="material-icons" (click)="increasing('UpdateAsc')"
              >keyboard_arrow_up</em
            >
            <em class="material-icons" (click)="decreasing('UpdateDsc')"
              >keyboard_arrow_down</em
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.lastUpdatedDate | date: "d MMM, yyyy" }}
          </mat-cell>
        </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns"></mat-row>
      </mat-table>
    </app-scroll-container>
    <div *ngIf="isLoadMoreInProgress">
      <cx-spinner></cx-spinner>
    </div>
    <div class="currently-loading-spinner" *ngIf="currentlyLoading && !isLoadMoreInProgress">
      <cx-spinner></cx-spinner>
    </div>
  </div>
  <div *ngIf="noData" class="noData">
    <div class="img"></div>
    <h2 class="heading">{{ "orderTracking.noOrdersFound" | cxTranslate }}</h2>
  </div>
</div>
